import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles<{ isVisible: boolean }>()(
  ({ palette, breakpoints }, { isVisible }) => ({
    root: {
      position: "fixed",
      color: "white"
    },
    link: {
      position: "fixed",
      background: palette.grey[700],
      color: "white",
      padding: "10px",
      opacity: isVisible ? "100%" : "0%",
      zIndex: -9999,
      textDecoration: "none",
      userSelect: "none",
      cursor: "pointer",
      [breakpoints.down("sm")]: {
        fontSize: "1.0rem"
      }
    }
  })
)
